module.exports = __webpack_public_path__ + "static/img/erweima.7cb3b674.png";